var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "v-container",
        { staticClass: "text-center" },
        [
          _c("h1", [_vm._v("Category")]),
          _c("v-text-field", {
            attrs: {
              filled: "",
              "data-cy": "FormCategory-name",
              label: _vm.$$t("name"),
            },
            model: {
              value: _vm.localCategory.name,
              callback: function ($$v) {
                _vm.$set(_vm.localCategory, "name", $$v)
              },
              expression: "localCategory.name",
            },
          }),
          _c("v-img", {
            attrs: { src: _vm.localCategory.photo, contain: "", height: "320" },
          }),
          _c("ImageUpload", {
            attrs: { label: "Photo" },
            model: {
              value: _vm.localCategory.photo,
              callback: function ($$v) {
                _vm.$set(_vm.localCategory, "photo", $$v)
              },
              expression: "localCategory.photo",
            },
          }),
          _c(
            "div",
            { staticClass: "d-flex justify-end mb-6" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-4 btn-cancel",
                  attrs: {
                    color: "default",
                    outlined: "",
                    "data-cy": "FormCategory-button-cancel",
                  },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  attrs: {
                    color: "primary",
                    type: "submit",
                    loading: _vm.isLoading,
                    "data-cy": "FormCategory-button-save",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }